import React from 'react';

const mapActionColorAndName = (action) => {
  if (action === 'I') {
    return ['bg-green', 'Añadir'];
  } else if (action === 'U') {
    return ['bg-yellow', 'Actualizar'];
  } else if (action === 'D') {
    return ['bg-red', 'Borrar'];
  }
  return ['bg-white', action];
};

export const Capsule = ({value}) => {
  const [bgColor, name] = mapActionColorAndName(value);
  return <div className={`floating-capsule ${bgColor}`}>{name}</div>;
};

export const Cell = ({row, column}) => {
  const bgColor = row?.original?.modifications?.includes(column?.id) ? 'bg-blue' : 'bg-white';
  if (column?.id === 'dmlType') {
    return (
      <div className={`floating-fluid-cell ${bgColor}`}>
        <Capsule value={row?.original[column?.id]} />
      </div>
    );
  }
  if (column?.id.toLowerCase().includes('date')) {
    return (
      <div className={`floating-fluid-cell ${bgColor}`}>
        {row?.original[column?.id]?.substring(0, 10) || ''}
      </div>
    );
  }
  return (
    <div className={`floating-fluid-cell ${bgColor}`}>
      {row?.original[column?.id]}
    </div>
  );
};
